import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSearch from './state/search.reducer';
import { SearchFacade } from './state/search.facade';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(fromSearch.SEARCH_FEATURE_KEY, fromSearch.searchReducer)],
  providers: [SearchFacade],
})
export class SearchStoreModule {}
